<template>
    <button
        type="button"
        class="rounded-md text-tertiary hover:text-secondary focus:ring-2 focus:ring-blue-500 focus:outline-hidden dark:focus:ring-blue-800"
        :data-spec-class="dataSpecClass"
        @click="emits('click')"
    >
        <span class="sr-only">Close</span>
        <XMarkIcon
            class="size-5"
            aria-hidden="true"
        />
    </button>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';

interface Props {
    dataSpecClass?: string;
}

withDefaults(defineProps<Props>(), {
    dataSpecClass: 'button-close',
});

const emits = defineEmits(['click']);
</script>
